import { Button, ModalBody, ModalFooter } from "@chakra-ui/react";

import { TextFormInput } from "components/inputs";
import SubmitButton from "components/SubmitButton";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import { useFormContext } from "react-hook-form";
import { InviteNewUserInputProps } from "./InviteNewUserModal";

export const modalPadding = mobileStyleBreakpoint("0", "6");
const headingHeight = "48px";
const minButtonWidth = "76px";

const EmailVerificationForm = ({ onClose }: { onClose: () => void }) => {
  const {
    formState: { isSubmitting },
  } = useFormContext<InviteNewUserInputProps>();

  return (
    <>
      <ModalBody p={6}>
        <TextFormInput id="email" label="Email" />
      </ModalBody>
      <ModalFooter pb={8}>
        <Button
          w="89px"
          h={headingHeight}
          variant="outline"
          mr={3}
          onClick={onClose}
        >
          Cancel
        </Button>
        <SubmitButton
          isDisabled={isSubmitting}
          isLoading={isSubmitting}
          minW={minButtonWidth}
          h={headingHeight}
        >
          Next
        </SubmitButton>
      </ModalFooter>
    </>
  );
};

export default EmailVerificationForm;
